import ButtonWithConfirmation from '../../shared/components/ButtonWithConfirmation';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import Typography from '@mui/material/Typography';

interface LessonOpenMessageBoxProps {
  title: string;
  onConfirm: () => void;
}

function LessonOpenMessageBox(props: LessonOpenMessageBoxProps) {
  const message = (
    <Typography variant="body1">
      Looks like you have the lesson{' '}
      <span style={{ fontWeight: 'bold' }}>{props.title}</span> open in another
      tab. You can only open one lesson at a time. If you want to open a new
      lesson, use the button below to close your open lesson.
    </Typography>
  );

  return (
    <Dialog open={true}>
      <DialogTitle>Lesson in progress</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <ButtonWithConfirmation
          label="Exit Lesson"
          onConfirm={props.onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
}

export default LessonOpenMessageBox;
